import Matter from 'matter-js';
import { PhysicsType, Physics } from './Physics';
import { GameObject } from '@combos-fun/engine';
declare interface BodyOptions {
  chamfer?: number; // chamfer (bevel) size
  angle?: number; // rotation angle
  isStatic?: boolean;
  density?: number; // density
  restitution?: number; // restitution (bounciness)
  velocity?: number; // velocity
  speed?: number; // speed
  motion?: number; // motion (kinetic energy)
  mass?: number;
}

export interface RectangleParams {
  x: number;
  y: number;
  width: number;
  height: number;
  options: BodyOptions;
}

export interface Verctor {
  x: number;
  y: number;
}
export default class BodiesFactory {
  private Bodies: typeof Matter.Bodies;
  constructor() {
    this.Bodies = Matter.Bodies;
  }
  public create(component: Physics): Matter.Body {
    let body: Matter.Body = null;
    const { gameObject, bodyParams } = component;
    const coordinate = this.getCoordinate(gameObject);
    const x = bodyParams.position ? bodyParams.position.x : coordinate.x;
    const y = bodyParams.position ? bodyParams.position.y : coordinate.y;
    const halfW =
      (gameObject.transform.size.width * gameObject.transform.scale.x) / 2;
    const halfH =
      (gameObject.transform.size.height * gameObject.transform.scale.y) / 2;
    /** Matter.circle approximates with a polygon; NaN/0 radius breaks vertices. */
    const defaultRadius = Math.max(1, Math.min(halfW, halfH));
    switch (bodyParams.type) {
      case PhysicsType.RECTANGLE: {
        const width = gameObject.transform.size.width * gameObject.transform.scale.x;
        const height = gameObject.transform.size.height * gameObject.transform.scale.y;
        body = this.Bodies.rectangle(x, y, width, height, bodyParams.bodyOptions);
        break;
      }
      case PhysicsType.CIRCLE: {
        const radius = bodyParams.radius ?? defaultRadius;
        body = this.Bodies.circle(x, y, radius, bodyParams.bodyOptions);
        break;
      }
      case PhysicsType.POLYGON: {
        const sides = Math.max(3, bodyParams.sides ?? 6);
        const radius = bodyParams.radius ?? defaultRadius;
        body = this.Bodies.polygon(x, y, sides, radius, bodyParams.bodyOptions);
        break;
      }
    }
    return body;
  }

  private getCoordinate(gameObject: GameObject): Verctor {
    const x = gameObject.transform.position.x + gameObject.transform.anchor.x * gameObject.parent.transform.size.width;
    const y = gameObject.transform.position.y + gameObject.transform.anchor.y * gameObject.parent.transform.size.height;
    return {
      x,
      y,
    };
  }
}
